var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 44,
    viewBox: "0 0 32 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "v57yvui6ma",
    d: "M0 0h28.017v30.482H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br9qz6xsoc",
    d: "M0 0h7.947v8.128H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8l6e4hqi4e",
    d: "M0 0h7.845v10.003H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u1agogph9g",
    d: "M0 0h7.952v8.128H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.989 12.901)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tvtoiwo4zb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v57yvui6ma"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.726 25.64v-6.507h-2.563l5.127-8.873v6.507h2.563l-5.127 8.873zM14.84.325a1.222 1.222 0 0 0-1.66 0L.392 11.218a1.224 1.224 0 0 0 .83 2.124h1.767v17.141h22.037V13.342h1.765a1.226 1.226 0 0 0 .83-2.124L14.84.325z",
    fill: "#FFF",
    mask: "url(#tvtoiwo4zb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.787)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lossqnbzwd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#br9qz6xsoc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m5.567 7.72.08.074a1.394 1.394 0 0 0 1.89-2.045L4.733 2.943l1.371-1.37c.505-.506.338-.984-.371-1.061L1.157.008C.447-.07-.07.447.007 1.155l.506 4.576c.077.71.554.877 1.059.372l1.19-1.189L5.566 7.72z",
    fill: "#FFF",
    mask: "url(#lossqnbzwd)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.075)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "aaea06q2rf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8l6e4hqi4e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.718 5.022H2.53v3.586l.002.1a1.395 1.395 0 0 0 2.785-.1V5.022h1.81c.714 0 .933-.455.487-1.012L4.734.417C4.29-.14 3.558-.14 3.111.417L.231 4.01c-.446.557-.227 1.012.487 1.012",
    fill: "#FFF",
    mask: "url(#aaea06q2rf)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.048 5.786)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jrpaj0wrqh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u1agogph9g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.795.008 2.22.512c-.71.079-.878.555-.373 1.06l1.369 1.369L.409 5.749l-.074.08a1.393 1.393 0 0 0 2.045 1.89l2.807-2.807L6.38 6.103c.504.505.981.338 1.06-.372l.504-4.576C8.022.447 7.506-.07 6.795.008",
    fill: "#FFF",
    mask: "url(#jrpaj0wrqh)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.07303adadd503c4d2706327ec24b35bb.svg";
export { ForwardRef as ReactComponent };